export class AssistanceCaseQuestions {
  questions: string;
  answer: any;

  constructor(questions?: string) {
    this.questions = questions;
    this.answer = "";
  }
}
